import React, { useCallback, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, FormGroup, Input, Label, Row, UncontrolledAlert } from "reactstrap"
import TastyButton from "components/TastyButton"
import tastyworksApi from "utils/tastyworksApi"

const propTypes = {
  onCancel: PropTypes.func.isRequired
};

function ResetPasswordForm({ onCancel }) {
  const [email, setEmail] = useState('');
  const [apiError, setApiError] = useState(null);
  const [apiPending, setApiPending] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      setApiPending(true);
      setApiError(null);

      try {
        await tastyworksApi.resetPassword(email);

        setApiPending(false);
        setSuccess(true);
      } catch (error) {
        setApiError(error.message);
        setApiPending(false);

        return error;
      }
    },
    [email],
  );

  return (
    <Form onSubmit={handleSubmit}>
      {success && (
        <UncontrolledAlert color="success" className="small">A password reset email has been sent to your email if a tastyworks account exists.</UncontrolledAlert>
      )}
      {apiError && (
        <UncontrolledAlert color="danger" className="small">{apiError}</UncontrolledAlert>
      )}
      <Row className="align-items-center">
        <Col xs={6}>
          <h5 className="text-uppercase text-muted small m-0">Reset Password</h5>
        </Col>
        <Col xs={6} className="text-right">
          <Button color="link" size="sm" type="button" onClick={onCancel} className="p-0">
            Cancel
          </Button>
        </Col>
      </Row>
      <p className="mt-2 small">
        To reset your password, please enter the same email address you use to sign in to tastyworks in the field below.
        You&apos;ll receive an email from us with a link to reset your password within the next few minutes.
      </p>
      <FormGroup>
        <Label for="email" size="sm">
          Email
        </Label>
        <Input
          type="email"
          name="email"
          id="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={success}
          required
        />
      </FormGroup>

      <TastyButton primary type="submit" block size="lg" disabled={apiPending || success}>
        Submit
      </TastyButton>
    </Form>
  );
}

ResetPasswordForm.propTypes = propTypes;

export default ResetPasswordForm;
